import notreDamePopenguine from '@/assets/churches/notre_dame_popeguine.png';
import notreDameAfrique from '@/assets/churches/notre_dame_afrique.png';
import sacreCoeurDakar from '@/assets/churches/sacrecoeur_dkr.png';
import cathedraleDakar from '@/assets/churches/cathedrale_dkr.png';
import saintChristopheYoff from '@/assets/churches/st_christoph_yoff.png';
import enfantDeJesus from '@/assets/churches/Enfant_de_jesus.png';
import martyrOuganda from '@/assets/churches/paroisse_martyr_ouganda.png';
import saintPierreBaobab from '@/assets/churches/paroisse_stpierre_baobab.png';
import saintPaulGrandYoff from '@/assets/churches/paroisse_stpaul_gransyoff.png';
import churchFallbackCross from '@/assets/churches/church_fallback_cross.png';
import { normalizeRemoteMediaUrl } from '@/lib/media';

function normalizeChurchName(value: string) {
  return value
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, "'")
    .replace(/\s+/g, ' ');
}

const CHURCH_IMAGE_MAP: Record<string, string> = {
  [normalizeChurchName('Paroisse Notre-Dame de la Délivrande de Popenguine')]: notreDamePopenguine,
  [normalizeChurchName("Chapelle Notre-Dame d'Afrique")]: notreDameAfrique,
  [normalizeChurchName('Paroisse Sacré-Coeur Malenfant de Dakar')]: sacreCoeurDakar,
  [normalizeChurchName('Cathédrale Notre-Dame des Victoires')]: cathedraleDakar,
  [normalizeChurchName('Paroisse Saint-Christophe de Yoff')]: saintChristopheYoff,
  [normalizeChurchName("Quasi-Paroisse L'Enfant de Jesus")]: enfantDeJesus,
  [normalizeChurchName('Quasi-Paroisse L Enfant de Jesus')]: enfantDeJesus,
  [normalizeChurchName('Quasi-paroisse « L’Enfant-Jésus » à Tivaouane-Peulh')]: enfantDeJesus,
  [normalizeChurchName("Paroisse Martyrs de l'Ouganda")]: martyrOuganda,
  [normalizeChurchName('Paroisse Saint Pierre des Baobab')]: saintPierreBaobab,
  [normalizeChurchName('Paroisse Saint Pierre de Baobabs')]: saintPierreBaobab,
  [normalizeChurchName('Paroisse Saint Paul de Grand Yoff')]: saintPaulGrandYoff,
  [normalizeChurchName('Fondation Martyrs de l’Ouganda de Fayil')]: churchFallbackCross,
  [normalizeChurchName('Paroisse Marie Immaculée des Parcelles Assainies (MIPA)')]: churchFallbackCross,
  [normalizeChurchName('Paroisse Parcelle MIPA')]: churchFallbackCross,
  [normalizeChurchName('Abbaye Bénédictin de Keur Moussa')]: churchFallbackCross,
  [normalizeChurchName('Abbaye Bénédicte de Keur Moussa')]: churchFallbackCross,
  [normalizeChurchName('Abbaye Bénédictine de Keur Moussa')]: churchFallbackCross,
  [normalizeChurchName('Paroisse Saint François d’Assise de Keur Massar')]: churchFallbackCross,
  [normalizeChurchName("Paroisse Saint Francois d'Assise de Keur Massar")]: churchFallbackCross,
  [normalizeChurchName('Paroisse Notre-Dame de la Paix de Diamaguène')]: churchFallbackCross,
  [normalizeChurchName('Eglise Notre-Dame du Cap-Vert de Pikine')]: churchFallbackCross,
  [normalizeChurchName('Paroisse Notre Dame des Anges de Ouakam')]: churchFallbackCross,
  [normalizeChurchName('Paroisse Saint-Joseph de Dakar')]: churchFallbackCross,
  [normalizeChurchName('Paroisse Saint Jean Bosco')]: churchFallbackCross,
};

const DAKAR_DIOCESES = new Set([
  normalizeChurchName('Archidiocèse de Dakar'),
  normalizeChurchName('Diocèse de Dakar'),
  normalizeChurchName('Dakar'),
]);

export function getChurchImageUrl(churchName: string, fallbackUri?: string | null, diocese?: string | null) {
  const localImage = CHURCH_IMAGE_MAP[normalizeChurchName(churchName)];
  if (localImage) {
    return localImage;
  }

  const normalizedDiocese = diocese ? normalizeChurchName(diocese) : null;
  const isDakarChurch = normalizedDiocese ? DAKAR_DIOCESES.has(normalizedDiocese) : false;

  if (!isDakarChurch) {
    return churchFallbackCross;
  }

  return normalizeRemoteMediaUrl(fallbackUri) || churchFallbackCross;
}
